import { render, staticRenderFns } from "./AppLoading2.vue?vue&type=template&id=5bbd84e7&scoped=true&"
import script from "./AppLoading2.vue?vue&type=script&lang=js&"
export * from "./AppLoading2.vue?vue&type=script&lang=js&"
import style0 from "./AppLoading2.vue?vue&type=style&index=0&id=5bbd84e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd84e7",
  null
  
)

export default component.exports